'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'pen-paintbrush';
var width = 576;
var height = 512;
var aliases = ["pencil-paintbrush"];
var unicode = 'f618';
var svgPathData = 'M320.5 409.1C325.4 449.5 359.1 480 399.9 480H539.1C517.9 480 501.6 468.5 491.1 455.1C482.5 441.9 477.8 425 479.5 408.3C479.8 405.6 479.9 402.8 479.9 400C479.9 359.2 449.4 325.5 409.9 320.6L436.4 294.1C480.4 309.2 511.9 350.9 511.9 400C511.9 403.9 511.7 407.8 511.3 411.6C509.5 429.1 521.5 448 539.1 448H543.9C561.6 448 575.9 462.3 575.9 480C575.9 497.7 561.6 512 543.9 512H399.9C350.8 512 309.1 480.4 294 436.5L320.5 409.1zM18.75 109.3C-6.248 84.26-6.248 43.74 18.75 18.75C43.74-6.248 84.26-6.248 109.3 18.75L224 133.5L201.4 156.1L86.63 41.37C74.13 28.88 53.87 28.88 41.37 41.37C28.88 53.87 28.88 74.13 41.37 86.63L156.1 201.4L133.5 223.1L18.75 109.3zM405.2 16.97C427.1-4.899 462.5-4.899 484.4 16.97L527 59.6C548.9 81.47 548.9 116.9 527 138.8L214.3 451.6C202.9 462.9 188.9 471.2 173.5 475.8L52.51 511.4C46.9 513 40.83 511.5 36.69 507.3C32.55 503.2 30.1 497.1 32.65 491.5L68.23 370.5C72.76 355.1 81.09 341.1 92.44 329.7L405.2 16.97zM461.8 39.6C452.4 30.23 437.2 30.23 427.8 39.6L373 94.4L449.6 170.1L504.4 116.2C513.8 106.8 513.8 91.6 504.4 82.23L461.8 39.6zM98.93 379.6L71.63 472.4L164.4 445.1C174.7 442.1 184.1 436.5 191.6 428.9L426.1 193.6L350.4 117L115.1 352.4C107.5 359.9 101.9 369.3 98.93 379.6V379.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenPaintbrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;